<template>
    <div class="widget-columns">
        <div
            v-for="(column, i) in widgets"
            :key="`column-${i}`"
            class="column"
        >
            <div
                v-for="(widget, n) in column"
                :key="`widget-${n}`"
                class="widget-wrap"
            >
                <component
                    :is="widget.component"
                    v-if="hasComponent(widget.component)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { has } from 'lodash';
import * as widgets from './Widgets';

export default {
    components: {
        ...widgets,
    },

    computed: {
        /**
         * @returns {object} Sorted widgets.
         */
        widgets() {
            return this.$store.getters.sortedHomeWidgets;
        },
    },

    methods: {
        /**
         * Checks If the component is registered.
         *
         * @param   {string} component Component name.
         * @returns {boolean} Whether the component is registered or not.
         */
        hasComponent(component) {
            return has(this.$options.components, component);
        },
    },
};
</script>
